import * as PIXI from "pixi.js";
import Game from "../Game";

export default class Bg extends PIXI.Graphics {
  Game: Game;
  constructor(width: number, height: number) {
    super();
    this.Game = Game.getInstance();
    this.roundRect((width - height) / 4, 3, height + (width - height) / 2, height - 6, 3)
      .fill(0xffffcc)
      .stroke({
        color: 0x000000,
        width: 6
      })
    this.Game.bottomContainer.addChild(this);
  }
}